import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

export interface MetaData {
    title: string,
    description: string,
    image: string,
    keywords: string,
    authors?: string,
}

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor(
        private _httpClient: HttpClient
    ) { }


    getTeam() {
        return this._httpClient.get(`https://oxvsys.buildprohub-server.com/smart_form_engine/third_party/forms/68763107e67fd23922b512f6`);
    }
    getprice() {
        return this._httpClient.get(`https://oxvsys.buildprohub-server.com/smart_form_engine/third_party/forms/688084492ea3a0a922046cf0`);
    }
}